import { render, staticRenderFns } from "./collection.vue?vue&type=template&id=2f7e9d8e&scoped=true"
import script from "./collection.vue?vue&type=script&lang=js"
export * from "./collection.vue?vue&type=script&lang=js"
import style0 from "./collection.vue?vue&type=style&index=0&id=2f7e9d8e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f7e9d8e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2f7e9d8e')) {
      api.createRecord('2f7e9d8e', component.options)
    } else {
      api.reload('2f7e9d8e', component.options)
    }
    module.hot.accept("./collection.vue?vue&type=template&id=2f7e9d8e&scoped=true", function () {
      api.rerender('2f7e9d8e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/operationManagement/appNewRenovation/components/collection.vue"
export default component.exports